import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { LandAreaContainer } from '../../containers/filters/LandAreaContainer';

export const landArea: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: LandAreaContainer,
};
